import {
  costCategoryLabelTypes,
  CostCategoryLabel,
} from '@/types/thermostatCostCategoryControls'

export interface CostCategoryRange {
  min_cost_cents: number | null
  max_cost_cents: number | null
}

/**
 * Determines the cost category type based on cost range
 */
export function getCostCategoryTypeFromRange(
  costRange: CostCategoryRange,
): CostCategoryLabel {
  const { min_cost_cents, max_cost_cents } = costRange

  // Negative cost category
  if (max_cost_cents !== null && max_cost_cents <= 0) {
    return 'negative'
  }

  // Low cost category (starts at 0)
  if (min_cost_cents !== null && min_cost_cents === 0) {
    return 'low'
  }

  // High cost category (no upper limit)
  if (max_cost_cents === null) {
    return 'high'
  }

  // Medium cost category (everything else)
  return 'medium'
}

/**
 * Maps cost categories from API response to display format with proper ordering
 */
export function mapCostCategoriesToDisplay(
  costCategoryControls: CostCategoryRange[],
) {
  return [...costCategoryControls]
    .sort(
      (a, b) =>
        (a.min_cost_cents ?? Number.NEGATIVE_INFINITY) -
        (b.min_cost_cents ?? Number.NEGATIVE_INFINITY),
    )
    .map((c, i) => {
      const type = getCostCategoryTypeFromRange(c)

      // Adjust index for negative category presence
      const hasNegativeCategory = costCategoryControls.some(
        (cat) => cat.max_cost_cents !== null && cat.max_cost_cents <= 0,
      )

      const adjustedIndex = hasNegativeCategory ? i : i + 1

      return {
        ...c,
        type: costCategoryLabelTypes[adjustedIndex] || type,
      }
    })
}
